module.exports = __webpack_public_path__ + "img/platform-1.468773c5.png";